import React from 'react';
import { Box, Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Check from '@mui/icons-material/Check';
import Block from '@mui/icons-material/Block';
import Tune from '@mui/icons-material/Tune';
import { useTranslation } from 'react-i18next';
import { hexToPastel } from '../../../stylesSheets';

export default function EndpointChipsSummary({
  assignedGroups,
  catalogGroups,
  allClientGroups,
  overrides,
}) {
  const { t } = useTranslation();
  const currentTheme = useTheme();

  const getPastelColor = colorHex => {
    try {
      return hexToPastel(colorHex);
    } catch (e) {
      return colorHex;
    }
  };

  let totalAssignedEndpointsCount = 0;
  assignedGroups.forEach(groupName => {
    const group =
      catalogGroups.find(g => g.group_name === groupName) ||
      allClientGroups.find(g => g.group_name === groupName);
    if (group) {
      totalAssignedEndpointsCount += group.endpoints?.length || 0;
    }
  });

  const revokeCount = overrides.filter(o => o.type === 'revoke').length;
  const grantCount = overrides.filter(o => o.type === 'grant').length;
  const grantedCount = totalAssignedEndpointsCount - revokeCount + grantCount;
  const overridesCount = overrides.length;

  const summaryItems = [
    {
      label: `${grantedCount} ${t('cws_app.management.granted', 'GRANTED')}`,
      colorKey: 'success',
      icon: <Check fontSize="small" style={{ fontSize: '0.9rem' }} />,
    },
    {
      label: `${revokeCount} ${t('cws_app.management.revoked', 'REVOKED')}`,
      colorKey: 'error',
      icon: <Block fontSize="small" style={{ fontSize: '0.9rem' }} />,
    },
    {
      label: `${overridesCount} ${t(
        'cws_app.management.overrides',
        'OVERRIDES',
      )}`,
      colorKey: 'warning',
      icon: <Tune fontSize="small" style={{ fontSize: '0.9rem' }} />,
    },
  ];

  return (
    <Box
      sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
      {summaryItems.map((item, index) => {
        const baseColor =
          currentTheme.palette[item.colorKey]?.main || '#9e9e9e';
        const pastelBg = getPastelColor(baseColor);
        const textColor =
          currentTheme.palette[item.colorKey]?.dark ||
          currentTheme.palette.text.primary;

        return (
          <Chip
            key={item.colorKey}
            icon={React.cloneElement(item.icon, {
              style: { color: textColor, marginLeft: '4px' },
            })}
            label={item.label}
            size="small"
            sx={{
              backgroundColor: pastelBg,
              color: textColor,
              fontWeight: 'bold',
              fontSize: '0.65rem',
              borderRadius: '16px',
              border: '1px solid',
              borderColor: baseColor,
              px: 0.5,
              height: 22,
              '& .MuiChip-label': {
                paddingLeft: '4px',
                paddingRight: '6px',
              },
            }}
          />
        );
      })}
    </Box>
  );
}
